import React from "react";
import styles from "./index.module.scss";
import { Sidebar } from "primereact/sidebar";
import FilterMobileOptions from "../../Filter-mobile-buttons";
import ButtonC from "../../button";
import { useSearchParams } from "react-router-dom";
import { useInvList } from "../../../../hooks/react-query/inv-exchange/useInvList";

interface SortModelProps {
  showModel: boolean;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SortMobile({ showModel, setShowModel }: SortModelProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { refetch } = useInvList();
  const [orderValue, setOrderValue] = React.useState(
    searchParams.get("sortOrder") === "asc"
      ? "Active on Bottom"
      : "Active on Top"
  );
  const handleApply = async () => {
    const updatedParams = new URLSearchParams(searchParams);
    if (orderValue?.length > 0) {
      updatedParams.set(
        "sortOrder",
        orderValue === "Active on Top" ? "desc" : "asc"
      );
    } else {
      updatedParams.delete("sortOrder");
    }
    refetch();
    setSearchParams(updatedParams);
    setShowModel(false);
  };

  return (
    <Sidebar
      visible={showModel}
      position="top"
      onHide={() => setShowModel(false)}
      className={styles.FilterModel}
    >
      <div className={styles.SortSection}>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "Active on Top",
              code: "Active on Top"
            },
            {
              name: "Active on Bottom",
              code: "Active on Bottom"
            }
          ]}
          occupancy={orderValue}
          setOccupancy={setOrderValue}
          title={"Sort By"}
          border={false}
        />
      </div>
      <ButtonC
        disabled={false}
        type="button"
        label="Apply"
        size="large"
        tabIndex={29}
        className={styles.btn}
        onClick={() => handleApply()}
      />
    </Sidebar>
  );
}
